import MyTripsLoginContainer from "../pages/MyTripsLoginPage";
import { withPrismaProvider } from "../clientSide/PrismaProviders";
export default withPrismaProvider(MyTripsLoginContainer);